define('shared/initializer/form/adapters/Bootstrap2',[ 
    '$',
    './NativeForm', 
    'shared/lib/RSVP', 
    'shared/lib/ctor'
], function ( $, Form, RSVP, ctor ) {
    'use strict';

    /* Constants */
    var CLS_CONTROL_GROUP = 'control-group';
    var CLS_ERROR_MESSAGES_HASH = {
        'message': true
    };
    var selectorMessage = '';
    for(var key in CLS_ERROR_MESSAGES_HASH) {
        if (!CLS_ERROR_MESSAGES_HASH.hasOwnProperty(key)) {
            continue;
        }

        selectorMessage += '.' + key;
    }

    /* Private Methods */
    function passItemValidation() {
        this.$wrap
            .addClass('successed has-success')
            .removeClass('error')
            .removeClass('has-error');
    }

    function failItemValidation() {
        this.$wrap
            .addClass('error has-error')
            .removeClass('successed')
            .removeClass('has-success');
    }

    function resetItemValidation() {
        this.$wrap
            .removeClass('error')
            .removeClass('has-error')
            .removeClass('successed')
            .removeClass('has-success');
    }

    function getMessagesFromSiblings($cur) {
        var messages = {};
        $cur.siblings(selectorMessage).each(function(i, el){
            var clsList = el.classList || el.className.split(/\s+/);
            for(var l = clsList.length; l--; ) {
                if (CLS_ERROR_MESSAGES_HASH.hasOwnProperty(clsList[l])) {
                    continue;
                }
                messages[clsList[l]] = $(el).text();
            }
        });
        return messages;
    }

    function initSubItems () {
        var me = this;
        var $form = me.$form;
        var $all = $form.find(
            '.' + CLS_CONTROL_GROUP + ' input,' + 
            '.' + CLS_CONTROL_GROUP + ' select, ' +
            '.' + CLS_CONTROL_GROUP + ' script[type="text/generic-template"]'
        );

        var $cur;
        var fieldName;
        var fieldOptions;
        var selectorMessage = '';

        for(var key in CLS_ERROR_MESSAGES_HASH) {
            if (!CLS_ERROR_MESSAGES_HASH.hasOwnProperty(key)) {
                continue;
            }

            selectorMessage += '.' + key;
        }

        for( var l = $all.length; l--; ) {
            $cur = $all.eq( l );

            fieldName = $cur.attr('name').toLowerCase();
            
            if ( me.items[fieldName] ) {
                fieldOptions = me.items[fieldName];
            }
            else {
                fieldOptions = {};    
            }

            fieldOptions.$wrap = $cur.closest('.' + CLS_CONTROL_GROUP);
            fieldOptions.index = fieldOptions.$wrap.index('.' + CLS_CONTROL_GROUP);
            fieldOptions.pass = passItemValidation;
            fieldOptions.fail = failItemValidation;
            fieldOptions.reset = resetItemValidation;
            fieldOptions.messages = getMessagesFromSiblings($cur);

            if ( fieldOptions.$el && fieldOptions.$el.length > 0 )  {
                fieldOptions.$el = fieldOptions.$el.add($cur);
            }
            else {
                fieldOptions.$el = $cur;
            }

            me.items.set( 
                $cur.attr('name'), fieldOptions
            );
        }
    }

    /* Constructor */
    var Ctor = ctor( function ( ) {

        var me = this;

        me.base.apply( me, arguments );

        initSubItems.call( me );

    } ).inherit(Form);

    return Ctor;
});
